async function fetchApi(routes, config = {}) {
  // eslint-disable-next-line
  const url = process.env.VUE_APP_SERVER;
  config.headers = {
    ...(config?.headers || {
      // eslint-disable-next-line
      "x-api-key": process.env.VUE_APP_API_KEY_DEV,
      "Content-Type": "application/json",
    }),
  };
  if (window.token || localStorage.getItem("token"))
    config.headers.Authorization =
      window.token || localStorage.getItem("token");
  const responseJSON = await fetch(`${url}${routes}`, config),
    response = await responseJSON.json();

  if (
    responseJSON.status == 403 &&
    response.message ==
      "User is not authorized to access this resource with an explicit deny"
  ) {
    refreshToken();
  } else if (responseJSON.status == 403) {
    auditlogout();
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    location.reload();
    throw responseJSON.status;
  }

  if (responseJSON.status >= 400)
    throw (responseJSON.status == 400 && !response.message) ||
    response.errors 
      ? response.errors
      : responseJSON.status == 401 
      ? responseJSON.status
      : response.message;
  return response;
}

function login({ email, password, captchaToken }) {
  return fetchApi("/agent/authenticate", {
    method: "POST",
    body: JSON.stringify({
      email,
      password,
      passphrase: "stringOfPartnerDev",
      url: location.origin,
      captchaToken
    }),
  }).then((response) => {
    window.token = response.token;
    localStorage.setItem("token", response.token);
    localStorage.setItem("userInfo", response);
    return response;
  });
}

// send refresh token request
function refreshToken() {
  let token = localStorage.getItem("userInfo");
  if (token) {
    token = JSON.parse(token);
    return fetchApi("/key/refresh", {
      method: "POST",
      body: JSON.stringify({
        refresh: token.refresh,
        passphrase: "stringOfPartnerDev",
      }),
    }).then((response) => {
      if (response.token) {
        token.token = response.token;
        window.token = response.token;
        localStorage.setItem("userInfo", JSON.stringify(token));
        localStorage.setItem("token", response.token);
      }
    });
  }
}

// parse JWT
function parseJwt(token) {
  if (token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
  return false;
}

function branches(config = {}) {
  return fetchApi("/agent/branchesmenu/", config).catch(async (e) => {
    console.log(e);
    if (e == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      location.reload();
    }
    if (
      e ==
      "User is not authorized to access this resource with an explicit deny"
    ) {
      await refreshToken();
      branches(config);
    }
  });
}

// function urlSystem(config = {}) {
//   return fetchApi("/agent/geturlssystem/", config).catch((e) => console.log(e));
// }

function placeAtention(id) {
  if (!id) return;
  return fetchApi(`/agent/profilemenu/?branchId=${id}`).catch(async (e) => {
    console.log(e);
    if (e == 401) {
      auditlogout();
      localStorage.removeItem("userInfo");
      location.reload();
    }
    if (
      e ==
      "User is not authorized to access this resource with an explicit deny"
    ) {
      await refreshToken();
      placeAtention(id);
    }
  });
}

function workPlace({ branchId, workerId, force, waitingRoom }) {
  let data = {};
  if (waitingRoom) {
    data = {
      "waitingRoom.id": waitingRoom,
    };
  } else {
    data = {
      "branch.id": branchId,
      "worker.id": workerId,
      force,
    };
  }
  return fetchApi(`/agent/authenticate/workplace`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

function callTurn(params) {
  return fetchApi(`/agent/workstation/call`, {
    method: "POST",
    body: JSON.stringify(params),
  });
}

function callTurnById(options) {
  return fetchApi(`/agent/workstation/call`, {
    method: "POST",
    body: JSON.stringify(options),
  });
}

function cancelTurnManager() {
  return fetchApi(`/agent/workstation/cancelcall`, {
    method: "POST",
  });
}

function ocupationByBranchId(branchId, config = {}) {
  return fetchApi(`/agent/workstation/ocupation/${branchId}`, config);
}

function requeueManager() {
  return fetchApi(`/agent/workstation/requeue`, {
    method: "POST",
  });
}

function finishTurn(sercice_id = null) {
  let obj = { derivationMsg: "" };
  if (sercice_id) obj["service.id"] = sercice_id;
  return fetchApi(`/agent/workstation/finish`, {
    method: "POST",
    body: JSON.stringify(obj),
  });
}

function revokeTurn() {
  return fetchApi(`/agent/workstation/revoke`, {
    method: "POST",
    body: JSON.stringify({
      derivationMsg: "",
    }),
  });
}

function absentTurn() {
  return fetchApi(`/agent/workstation/absent`, {
    method: "POST",
  });
}

function auditlogout() {
  return fetchApi(`/agent/auditlogout`, {
    method: "POST",
  });
}

function getCompanyInfo(defaultbranch, config = {}) {
  return fetchApi(
    `/company/${defaultbranch.company.name}/branch/${defaultbranch.label}`,
    config
  );
}

function getqueueCompanyPost({ companyInfo }) {
  return fetchApi(
    `/queue/${companyInfo.turnos[0].tramite_id}/branch/${companyInfo.branch_id}/enqueue`,
    {
      method: "POST",
      body: JSON.stringify({
        cedulaIdentidad: "kkjyhzh9c0001318kc5yi4ndd",
        cuil: "kkjyhzh9c0001318kc5yi4ndd",
        cuit: "CC",
        dni: "87064020",
        firstName: "PEPITO PEREZ DEMO",
        lastName: "",
        phone: "",
      }),
    }
  );
}

function getWorkerStats(idWorkStation) {
  return fetchApi(`/agent/workstation/workerStats?id=${idWorkStation}`);
}

// /**
//  * Functión para actualizar el estado
//  *
//  * @param {any} {id, state}
//  */
function updateState({ id, name }) {
  return fetchApi(`/agent/workstation/updateState`, {
    method: "PUT",
    body: JSON.stringify({
      id,
      name,
    }),
  }).catch((e) => console.error(e));
}

function loggedUser(config = {}) {
  return fetchApi(`/agent/loggedUser/`, config);
}

function pollingWorkplace(query) {
  // alert(query);
  return !query || (query && !query.id)
    ? fetchApi(`/agent/workstation/polling`, {})
    : fetchApi(
        `/agent/workstation/polling?selectedQueueGroupId=${query.id}`,
        {}
      );
}

function workstationTurn(id) {
  return fetchApi(`/agent/workstation/turn/${id}`);
}

/**
 * Typification request
 */
function sendTypify(serciceId) {
  return fetchApi(`/agent/workstation/typify`, {
    method: "POST",
    body: JSON.stringify({
      "service.id": serciceId,
    }),
  });
}

function getDerivableQueueGroups(config = {}) {
  try {
    return fetchApi(`/agent/workstation/getDerivableQueueGroups`, config);
  } catch (error) {
    console.log(error);
  }
}

function getSelectedQueue(id, config = {}) {
  return fetchApi(`/agent/workstation/selectedqueue/${id}`, config);
}

/**
 * Glued request
 */
function getQueuedDetails(id, config = {}) {
  return fetchApi(`/agent/workstation/getqueueddetails/${id}`, config);
}

function getAllTurns(config = {}) {
  return fetchApi(`/agent/workstation/allturns`, config);
}

function getQueueTurns(id, config = {}) {
  return fetchApi(`/agent/workstation/queueturns/${id}`, config);
}

function getTurnDataToCall(id, config = {}) {
  return fetchApi(`/agent/workstation/turn/${id}`, config);
}

function getUuidTypesByCompany(config = {}) {
  try {
    return fetchApi(`/agent/uuidTypesByCompany`, config);
  } catch (error) {
    console.log(error);
    return false;
  }
}

function getCustomerDetail(id, config = {}) {
  return fetchApi(`/agent/customerfromturn/${id}`, config);
}

function getCustomerTypes(config = {}) {
  return fetchApi(`/agent/customers/types`, config);
}

function getAbstenTurns(config = {}) {
  return fetchApi(`/agent/workstation/absentTurns`, config);
}

/**
 * Update user
 *
 * @param {Object} dataObj
 * @returns
 */
function updateCustomers(dataObj) {
  return fetchApi(`/agent/updateCustomers`, {
    method: "POST",
    body: JSON.stringify(dataObj),
  });
}

/**
 * Derivate request
 */
function sendDerivate(dataObj) {
  return fetchApi(`/agent/workstation/derivate`, {
    method: "POST",
    body: JSON.stringify(dataObj),
  });
}

/**
 *
 * Cancel derivate
 *
 * @param {any} dataObj
 * @returns
 */
function cancelDerivation(dataObj) {
  return fetchApi(`/agent/workstation/cancelderivation`, {
    method: "POST",
    body: JSON.stringify(dataObj),
  });
}

/**
 * Delete customer from turn request
 */
function removeCustomerFromTurn(dataObj) {
  return fetchApi(`/agent/removeCustomerFromTurn`, {
    method: "POST",
    body: JSON.stringify(dataObj),
  });
}

/**
 * Delete customer from turn request
 */
function findAndAssignCustomer(dataObj) {
  return fetchApi(`/agent/findAndAssignCustomer`, {
    method: "POST",
    body: JSON.stringify(dataObj),
  });
}

/**
 *
 * @returns
 */
function getEnvironment() {
  return fetchApi(`/environment`, {
    method: "POST",
    body: JSON.stringify({
      url: location.origin,
    }),
  });
}

/**
 *
 * @param {*} obj
 * @returns
 */
function reCallTurn() {
  return fetchApi(`/agent/workstation/recall`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

/**
 * (TOCA REVISAR ESTO)
 */
function sendAggregated(obj) {
  obj = {
    endDate: currentDateFormat(),
    listObjects: [
      {
        objects: [
          { id: 3069, type: "QUEUE" },
          { id: 0, type: "BRANCH" },
        ],
      },
      {
        objects: [
          { id: 3109, type: "QUEUE" },
          { id: 0, type: "BRANCH" },
        ],
      },
    ],
    measure: "WAITING",
    page: 1,
    pageSize: 31,
    period: "DAY",
    startDate: currentDateFormat(),
    type: "AVERAGE",
  };
  return fetchApi(`/agent/stats/aggregated`, {
    method: "POST",
    body: JSON.stringify(obj),
  });
}

/**
 *
 * We obtain the current date
 *
 * @returns String
 */
function currentDateFormat() {
  var currentDate = new Date();
  var day = currentDate.getDate();
  day = day > 9 ? day : "0" + day;
  var month = currentDate.getMonth() + 1;
  month = month.length > 1 ? month : "0" + month;
  var year = currentDate.getFullYear();
  return `${year}-${month}-${day}T00:00:00-0500`;
}

function autoRefreshToken() {
  let refre = setInterval(() => {
    let time = 0;
    let tokenInfo = parseJwt(window.token);
    time = (tokenInfo.exp * 1000 - Date.now()) / 1000;
    if (time < 30) {
      // less 30s
      console.log("refrescar");
      refreshToken();
      return false;
    } else clearInterval(refre);
  }, 3000);
}

function getUsers(config = {}) {
  return fetchApi(`/agent/users`, config);
}

function tracking(info) {
  // if (typeof info !== "object" || !info.uuid || !info.accion || !info.debmedia_turn_code || !info.url_origen || !info.origen  || !info.mensajes)
  //   console.error('Invalid paramethers for data records')
  return fetchApi("/tracking", {
    method: "POST",
    body: JSON.stringify(info),
  });
}

async function fetchAppointments(queryString = "") {
  await refreshToken();
  return fetchApi("/fetch_appointments?" + queryString, {
    method: "GET",
    headers: {
      "x-api-key": process.env.VUE_APP_API_KEY_DEV,
      "Content-Type": "application/json",
    },
  });
}

async function fetchAppointmentsExport(queryString = "", config = {}) {
  await refreshToken();
  return fetchApi("/export_appointments?" + queryString, {
    method: "GET",
    headers: {
      "x-api-key": process.env.VUE_APP_API_KEY_DEV,
      "x-api-token": config["x-api-token"],
      "Content-Type": "application/json",
    },
  });
}

async function sendDataProcessing(data) {
  await refreshToken();
  return new Promise((resolve) => {
    fetchApi(`/data_processing`, {
      method: "POST",
      body: JSON.stringify(data),
    }).then((res) => {
      resolve(res);
    });
  });
}

async function getCauseList(company) {
  await refreshToken();
  return new Promise((resolve) => {
    fetchApi(`/cause_not_delivery${company ? "?company=" : ""}`, {
      method: "GET",
    }).then((res) => {
      resolve(res);
    });
  });
}

async function sendNotification(code) {
  return code;
  // await refreshToken();
  // return new Promise(resolve => {
  //   fetchApi(`/send_notification`, {
  //     method: "POST",
  //     body: JSON.stringify({
  //       turn_code: code
  //     })
  //   }).then(res => {
  //     resolve(res);
  //   });
  // })
}

async function fetchDoctorAppointments(params) {
  const server = params.VUE_APP_FSFB_SERVER_STAFF_APPOINTMENTS;
  const raw = {
    start_date: params.fromDate,
    end_date: params.toDate,
    doc: params.doc,
    tdoc: "4",
  };

  let externalData = {
    data: raw,
    url: server,
    contentType: "application/json",
    token: "fsfb",
    stringify: true,
    authHeader: "x-api-key",
  };

  return fetchApi(`/mirror_request`, {
    method: "POST",
    body: JSON.stringify(externalData),
    headers: {
      "x-api-key": params.VUE_APP_API_KEY_DEV,
    },
  });
}

async function fetchMonitorTurns(params) {
  await refreshToken();
  return fetchApi(
    `/fetch_turns?fromDate=${params.fromDate}&toDate=${params.toDate}&branch_id=${params.branch_id}&mainLoading=${params.mainLoading} `
  );
}

async function fetchCupsCode(params) {
  const server = params.VUE_APP_FSFB_SERVER_KIOSKOS_DISTRIBUTION;

  let externalData = {
    data: {},
    method: "GET",
    url: server + params.speciality.toUpperCase().split('_')[0],
    contentType: "application/json",
    token: "fsfb",
    stringify: true,
    authHeader: "x-api-key",
  };

  return fetchApi(`/mirror_request`, {
    method: "POST",
    body: JSON.stringify(externalData),
    headers: {
      "x-api-key": params.VUE_APP_API_KEY_DEV,
    },
  });
}

async function sendLogRecorders(params, resolve){
  // console.log(params)
  await refreshToken();
  return fetchApi("/recorders/logs", {
    method: "POST",
    body: JSON.stringify(params),
  }).then((response) => {
    resolve(response);
  }).catch(e=>{
    console.error("ERROR SAVING LOG")
    console.log(e)
    sendLogRecorders(params, resolve);
  });
  // resolve(true);
}

let retry = 0;
async function fetchLogRecorders(params, resolve){
  // console.log(params)
  await refreshToken();
  return fetchApi(`/recorders/logs?turn_code=${params.turn_code}&date=${params.date}&user=${params.user}`, {
    method: "GET",
  })
  .then(data => data.data)
  .then((response) => {
    resolve(response);
  }).catch(e=>{
    console.error("ERROR FETCHING LOG")
    console.log(e)
    retry++;
    if(retry > 3){
      retry = 0;
      return resolve([]);
    }
    fetchLogRecorders(params, resolve);
  });
  // resolve(true);
}

export {
  fetchApi,
  login,
  branches,
  getCompanyInfo,
  // urlSystem,
  getqueueCompanyPost,
  placeAtention,
  workPlace,
  loggedUser,
  callTurn,
  callTurnById,
  getWorkerStats,
  finishTurn,
  pollingWorkplace,
  revokeTurn,
  updateState,
  getDerivableQueueGroups,
  workstationTurn,
  sendTypify,
  getSelectedQueue,
  getQueuedDetails,
  getUuidTypesByCompany,
  getCustomerDetail,
  getCustomerTypes,
  getAllTurns,
  cancelTurnManager,
  getQueueTurns,
  getTurnDataToCall,
  requeueManager,
  sendDerivate,
  cancelDerivation,
  sendAggregated,
  updateCustomers,
  ocupationByBranchId,
  removeCustomerFromTurn,
  findAndAssignCustomer,
  absentTurn,
  getAbstenTurns,
  auditlogout,
  getEnvironment,
  reCallTurn,
  autoRefreshToken,
  getUsers,
  tracking,
  fetchAppointments,
  fetchAppointmentsExport,
  sendDataProcessing,
  getCauseList,
  sendNotification,
  refreshToken,
  fetchDoctorAppointments,
  fetchMonitorTurns,
  fetchCupsCode,
  sendLogRecorders,
  fetchLogRecorders
};
